'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../../styles/templates/collection.scss');

require('../sections/template-collection');

require('../sections/index-blog');

require('../sections/index-ingredients');

(0, _themeSections.load)(['template-collection', 'index-blog', 'index-ingredients']);

// Collection & global sections